<template>
  <v-row class="px-3">

    <v-col cols="12" class="px-0">
      <div class="accent--text font-weight-bold">Тип заявления</div>
      <div class="accent--text">{{application.applicationType?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Статус заявления</div>
      <div class="accent--text">{{application.applicationStatus?.name}}</div>
    </v-col>

    <v-col cols="12" class="px-0 border-top">
      <Title title="Текущая специальность" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" class="px-0 border-top">
      <div class="accent--text font-weight-bold">Специальность</div>
      <div class="accent--text">{{application.specialityFrom?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Номер курса</div>
      <div class="accent--text">{{application.courseNumberFrom?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Группа</div>
      <div class="accent--text">{{application.group?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Тип обучения</div>
      <div class="accent--text">{{application.paidFormFrom?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Форма обучения</div>
      <div class="accent--text">{{application.educationFormFrom.name}}</div>
    </v-col>

    <v-col cols="12" class="px-0 border-top">
      <Title title="Желаемая специальность" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" class="px-0 border-top">
      <div class="accent--text font-weight-bold">Специальность</div>
      <div class="accent--text">{{application.specialityTo?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Номер курса</div>
      <div class="accent--text">{{application.courseNumberTo?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Тип обучения</div>
      <div class="accent--text">{{application.paidFormTo?.name}}</div>
    </v-col>

    <v-col cols="12" class="pt-0 px-0">
      <div class="accent--text font-weight-bold">Форма обучения</div>
      <div class="accent--text">{{application.educationFormTo?.name}}</div>
    </v-col>
  </v-row>
</template>

<script>
import {Application} from "@/models";
import Title from "@/components/ui/Title";

export default {
  name: "ApplicationRecovery",

  components: {
    Title
  },

  props: {
    application: Application
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
